import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import PageLoader from '../components/PageLoader';
import { getAuthHeaders, getPaymentsBaseUrl, isB2BMode } from '../utils/bookingsBase';

export default function PaiementEnCours() {
  const { bookingId } = useParams();
  const history = useHistory();
  const [tries, setTries] = useState(0);

  useEffect(() => {
    let cancelled = false;

    const tick = async () => {
      try {
        const base = getPaymentsBaseUrl();

        // 👉 idéalement: ton backend expose /worldline/:id/status (sans hostedCheckoutId)
        // Mais si tu n'as pas ça, tu peux stocker hostedCheckoutId dans booking au moment init.
        const { data } = await axios.get(`${base}/worldline/${bookingId}/status`, {
          headers: getAuthHeaders(),
          timeout: 15000,
        });

        if (cancelled) return;

        const b2b = isB2BMode();
        const failUrl = b2b
          ? `/b2b/paiement-refuse/${bookingId}`
          : `/paiement-refuse/${bookingId}`;

        if (data?.ok && data?.paid) {
          history.replace(
            b2b ? `/b2b/confirmation/${bookingId}` : `/confirmation/${bookingId}`,
          );
          return;
        }
        if (data?.ok && data?.failed) {
          history.replace(failUrl);
          return;
        }

        setTries((t) => t + 1);
      } catch {
        setTries((t) => t + 1);
      }
    };

    tick();
    const id = setInterval(tick, 4000);

    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [bookingId, history]);

  return (
    <>
      <PageLoader show={true} label="Paiement en cours de validation…" />
      <div className="p-4 text-center">
        <small>Vérification automatique… ({tries})</small>
      </div>
    </>
  );
}
